import { z, ZodType } from 'zod';
import { WidgetsName, WidgetType } from './common';
import { zObject } from '../../util/zod';

export type DatasourceDataTypeUrl = {
    title: string;
    url: string;
};

export const DateFormatSchema = z.enum(['date', 'date-time', 'date-time-sec', 'time', 'time-sec']);
export type DateFormat = z.infer<typeof DateFormatSchema>;

export const NumberFormatSchema = z.enum(['fr-FR', 'en-EN', 'filesize']);
export type NumberFormat = z.infer<typeof NumberFormatSchema>;

export const widgetTableColumnWidgetDefaulSchema = z.object({});
export type WidgetTableColumnWidgetDefault = z.infer<typeof widgetTableColumnWidgetDefaulSchema>;

export const widgetTableColumnWidgetTextSchema = z.object({
    type: z.literal('text'),
});
export type WidgetTableColumnWidgetText = z.infer<typeof widgetTableColumnWidgetTextSchema>;

export const widgetTableColumnWidgetSelectOptionSchema = z.object({
    label: z.string(),
    value: z.string(),
});
export const widgetTableColumnWidgetSelectSchema = z.object({
    type: z.literal('select'),
    options: widgetTableColumnWidgetSelectOptionSchema.array(),
});

export type WidgetTableColumnWidgetSelect = z.infer<typeof widgetTableColumnWidgetSelectSchema>;

export const widgetTableColumnWidgetDateSchema = z.object({
    type: z.literal('date'),
});
export type WidgetTableColumnWidgetDate = z.infer<typeof widgetTableColumnWidgetDateSchema>;

export const widgetTableColumnWidgetsSchema = z.union([
    widgetTableColumnWidgetTextSchema,
    widgetTableColumnWidgetSelectSchema,
    widgetTableColumnWidgetDateSchema,
    widgetTableColumnWidgetDefaulSchema,
]);
export type WidgetTableColumnWidgets = z.infer<typeof widgetTableColumnWidgetsSchema>;

export const widgetTableColumnDataSchema = z.object({
    name: z.string().optional(),
    isVisible: z.boolean().optional(),
    textEllipsis: z.boolean().optional(),
    label: z.string().optional(),
    dateFormat: DateFormatSchema.optional(),
    numberFormat: NumberFormatSchema.optional(),
});

export type WidgetTableColumnData = z.infer<typeof widgetTableColumnDataSchema>;

export const widgetTableColumnsData = widgetTableColumnDataSchema.array();
export type WidgetTableColumnsData = z.infer<typeof widgetTableColumnsData>;

export const widgetTableColumnTypesSchema = z.enum([
    'text',
    'uri',
    'file',
    'select',
    'url',
    'transient',
    'date',
    'datetime',
    'email',
    'number',
    'title',
]);
export type WidgetTableColumnTypes = z.infer<typeof widgetTableColumnTypesSchema>;

export const widgetTableColumnSchema = z.object({
    name: z.string(),
    label: z.string(),
    sortable: z.boolean().optional(),
    type: widgetTableColumnTypesSchema,
    widget: widgetTableColumnWidgetsSchema,
});

export type WidgetTableColumn = z.infer<typeof widgetTableColumnSchema>;

export const widgetTableContentSchema = z.object({
    limit: z.number().or(z.boolean()).optional(),
    tableColumnsData: widgetTableColumnDataSchema.array().optional(),
    tableHeadColor: z.string().optional(),
    tableHeadTextColor: z.string().optional(),
    tableHeadIconColor: z.string().optional(),
    tableRowColor: z.string().optional(),
    tableRowTextColor: z.string().optional(),
    tableBorderRadius: z.number().optional(),
    tableSizedColumns: z.boolean().optional(),
    tableSizedColumnsWidth: z.number().optional(),
});

export type WidgetTableContent = z.infer<typeof widgetTableContentSchema>;

export type WidgetDatasourceValues = string | number | DatasourceDataTypeUrl;

export const widgetDatasourceTableContentSchema = widgetTableContentSchema.extend({
    uri: z.string().optional(),
});
export type WidgetDatasourceTableContent = z.infer<typeof widgetDatasourceTableContentSchema>;

export type WidgetDatasourceTableType = {
    name: WidgetsName.DatasourceTable;
    uniqid: string;
    content: WidgetDatasourceTableContent;
};
export const widgetDatasourceTableTypeSchema = zObject<WidgetDatasourceTableType>({
    name: z.literal(WidgetsName.DatasourceTable),
    uniqid: z.string(),
    content: widgetDatasourceTableContentSchema,
}) satisfies ZodType<WidgetType<WidgetDatasourceTableContent>>;
